<template>
  <table class="w-full text-left">
    <thead>
      <tr>
        <th v-if="language == 'en'">Assessment ID</th>
        <th v-else>评估者ID编号</th>

        <th v-if="language == 'en'">Is Main</th>
        <th v-else>重置</th>

        <th v-if="language == 'en'">Created</th>
        <th v-else>创建时间</th>

        <th v-if="language == 'en'">Last Update</th>
        <th v-else>更新时间</th>

        <th v-if="language == 'en'">Recommendation</th>
        <th v-else>推荐</th>

        <th class="text-center" v-if="language == 'en'">Actions</th>
        <th class="text-center" v-else>操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(assessment, index) in assessments" :key="index">
        <td>{{assessment.id}}</td>

        <td v-if="language == 'en'">{{isMain(assessment) ? "Yes" : "No"}}</td>
        <td v-else>{{isMain(assessment) ? "是" : "否"}}</td>

        <td>{{assessment.created_at.split('T')[0]}}</td>
        <td>{{assessment.updated_at.split('T')[0]}}</td>

        <td v-if="language == 'en'">{{hasRecommendation(assessment) ? "Yes" : "No"}}</td>
        <td v-else>{{hasRecommendation(assessment) ? "是" : "否"}}</td>

        <td class="text-center">
          <a
            class="cursor-pointer"
            v-if="language == 'en'"
            @click="$emit('viewAssessment', assessment)"
          >View</a>
          <a class="cursor-pointer" v-else @click="$emit('viewAssessment', assessment)">浏览</a>
          |
          <a
            class="cursor-pointer"
            v-if="language == 'en'"
            @click="$emit('deleteAssessment', assessment)"
          >Delete</a>
          <a class="cursor-pointer" v-else @click="$emit('deleteAssessment', assessment)">删除</a>
          |
          <a
            class="cursor-pointer"
            v-if="language == 'en'"
            @click="$emit('editAssessment', assessment)"
          >Edit</a>
          <a class="cursor-pointer" v-else @click="$emit('editAssessment', assessment)">编辑</a>
          |
          <a
            class="cursor-pointer"
            v-if="language == 'en'"
            @click="$emit('setMain', assessment)"
          >Set Main</a>
          <a class="cursor-pointer" v-else @click="$emit('setMain', assessment)">重置</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["assessments", "language"],
  methods: {
    hasRecommendation(assessment) {
      if (assessment.main_recommendation_id != null) {
        return true;
      }

      return false;
    },
    isMain(assessment) {
      if (!assessment.is_main) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    table-layout: fixed;
  }

  tr{
      background-color: #eff8ff80;
  }

  tbody{
      background-color: #f9faff;
  }

  td, th {
    text-align: left;
    word-break: break-word;
    border: 1px solid rgba(52,144,220,0.5);
    width: 20%;
    padding: .5em;
  }

  a.cursor-pointer{
      display: block;
  }
}
</style>